import { PlaceRepository, Place, PlaceRepositoryError, PlaceFactory } from '@/Domain/Localization/Place'
import { ParishCode } from '@/Domain/Localization/Parish'
import { ApiClient, Api500Error } from '@/Domain/ApiClient'
import { AxiosPlaceData } from './AxiosPlaceData'

export class AxiosPlaceRepository implements PlaceRepository {
  private _apiClient: ApiClient
  private _placeFactory: PlaceFactory<AxiosPlaceData>

  constructor (apiClient: ApiClient, placeFactory: PlaceFactory<AxiosPlaceData>) {
    this._apiClient = apiClient
    this._placeFactory = placeFactory
  }

  async byParishId (parishCode: ParishCode): Promise<Place[]> {
    try {
      const response = await this._apiClient.makeGetRequest(
        '/sobree/api/localization/place/' + parishCode.value(),
        {}
      )
      const places = response.data.data.places.map((current: AxiosPlaceData) => {
        return this._placeFactory.makePlace(current)
      })
      return places
    } catch (error) {
      if (error instanceof Api500Error) {
        return Promise.reject(new PlaceRepositoryError('Server not responding'))
      }
      return Promise.reject(error)
    }
  }
}
